export const DownloadTemplate = ({
  href,
  text,
  className,
}: {
  href: string | undefined
  text: string
  className?: string
}) => {
  return (
    <a
      className={`btn btn-active-primary btn-active-icon-white btn-light-primary fw-bold fs-base ms- min-w-200px ${className}`}
      download={true}
      href={href}
    >
      <span className='svg-icon svg-icon-6 svg-icon-muted me-2 mb-1'>
        <svg
          width='14'
          height='15'
          viewBox='0 0 14 15'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            opacity='0.5'
            d='M7.00041 0.500108C7.22667 0.500463 7.44368 0.593641 7.6036 0.759192C7.76366 0.924623 7.85375 1.14906 7.8541 1.38307V7.26761L10.5516 4.94237C10.7256 4.79267 10.9499 4.72053 11.1752 4.74182C11.4005 4.76299 11.6086 4.87568 11.7535 5.05528C11.8985 5.23526 11.9683 5.46737 11.9478 5.70068C11.9273 5.93387 11.8181 6.14919 11.6443 6.29915L7.5468 9.83097C7.5037 9.86243 7.45797 9.88986 7.41018 9.91292C7.37919 9.93396 7.34707 9.95312 7.31391 9.97015C7.11475 10.0568 6.8902 10.0568 6.69106 9.97015C6.6579 9.95336 6.626 9.93432 6.59548 9.91292C6.54643 9.88998 6.49956 9.8623 6.45542 9.83026L2.35788 6.29844C2.1777 6.14271 2.06748 5.91686 2.05331 5.67445C2.03914 5.43192 2.12226 5.194 2.283 5.01685C2.44375 4.83971 2.66794 4.73897 2.9029 4.73814C3.10252 4.73885 3.29562 4.81122 3.44928 4.94307L6.14675 7.26761V1.38307C6.1471 1.14905 6.23719 0.924598 6.39725 0.759192C6.55719 0.593641 6.77417 0.500462 7.00041 0.500108Z'
            fill='currentColor'
          />
          <path
            d='M13.1462 9.85042C12.9199 9.85077 12.7029 9.94395 12.543 10.1094C12.383 10.2749 12.2929 10.4993 12.2925 10.7333V12.6757H1.70739V10.7333C1.70739 10.4179 1.5447 10.1264 1.28048 9.96865C1.01638 9.81091 0.690992 9.81091 0.426906 9.96865C0.162693 10.1264 0 10.4179 0 10.7333V13.5587C0.000342994 13.7927 0.0904326 14.0171 0.250494 14.1826C0.410439 14.348 0.627439 14.4412 0.853682 14.4415H13.1463C13.3726 14.4412 13.5896 14.348 13.7495 14.1826C13.9096 14.017 13.9997 13.7927 14 13.5587V10.7333C13.9997 10.4992 13.9096 10.2749 13.7495 10.1094C13.5896 9.94395 13.3726 9.85077 13.1463 9.85042H13.1462Z'
            fill='currentColor'
          />
        </svg>
      </span>

      <span className='csvTemplate'>{text} </span>
    </a>
  )
}
